import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const BreadcrumbV3 = props => {
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-0 font-size-18">{props.title}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {
                props.breadcrumbItems.map((item, index) => (
                  <BreadcrumbItem key={index}>
                    <Link to={item.link}>{item.item}</Link>
                  </BreadcrumbItem>
                ))
              }
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

BreadcrumbV3.propTypes = {
  breadcrumbItem: PropTypes.array,
  title: PropTypes.string
}

export default BreadcrumbV3
